/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ValidateCouponRequestBillingCadence } from './validateCouponRequestBillingCadence';
import type { ValidateCouponRequestPlanSlug } from './validateCouponRequestPlanSlug';

export interface ValidateCouponRequest {
  /**
     * @minLength 1
     * @maxLength 100
     */
  code: string;
  plan_slug?: ValidateCouponRequestPlanSlug;
  billing_cadence?: ValidateCouponRequestBillingCadence;
}
